import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=3e0bfd9e&scoped=true"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=3e0bfd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0bfd9e",
  null
  
)

export default component.exports